import React from "react"

import SEO from "@components/seo"
import styles from "./index.module.scss"
import Button from "@components/button"

import IntroVideo from "@components/pages/index/introVideo"
import Intro from "@components/pages/index/intro"
import EventInfo from "@components/pages/index/eventInfo"
import Plane from "@components/pages/index/plane"
import Arc from "@components/pages/index/arc"
import Playable from "@components/pages/index/playable"
import ChallengeGames from "@components/pages/index/challengeGames"
import Market from "@components/pages/index/market"
import StageEvents from "@components/pages/index/stageEvents"
import SpecialGuests from "@components/pages/index/specialGuests"
import Footer from "@components/pages/index/footer"

const IndexPage = () => {
  return (
    <>
      <SEO />
      <IntroVideo />
      <div className={styles.container}>
        <Intro />
        <EventInfo />
        <Plane />
        <Arc />
        <Playable />
        <ChallengeGames />
        <Market />
        <StageEvents />
        <SpecialGuests />
        <Footer />
      </div>
    </>
  )
}

export default IndexPage
